import { render, staticRenderFns } from "./ImportTablePPP3.vue?vue&type=template&id=4bf3fdf6&"
import script from "./ImportTablePPP3.vue?vue&type=script&lang=js&"
export * from "./ImportTablePPP3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports